import React, { useEffect, useRef } from 'react';
import { FaGlobe, FaHandshake, FaLightbulb, FaUsers } from 'react-icons/fa';
import { MdBusinessCenter } from 'react-icons/md';

const CARDS = [
    { icon: <FaGlobe />,       title: 'Our Mission',  text: "To connect Sierra Leone's businesses to world-class opportunities and sustainable growth." },
    { icon: <FaLightbulb />,   title: 'Our Vision',   text: 'A thriving West African economy powered by innovative, locally-led enterprise.' },
    { icon: <FaHandshake />,   title: 'Our Values',   text: 'Integrity, excellence, and community impact guide every engagement we undertake.' },
    { icon: <FaUsers />,       title: 'Our Team',     text: '35+ seasoned professionals across strategy, technology, finance, and operations.' },
];

function About() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const el = sectionRef.current;
        if (!el) return;
        const targets = el.querySelectorAll('.fade-up');
        const observer = new IntersectionObserver(
            entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } }),
            { threshold: 0.1 }
        );
        targets.forEach(t => observer.observe(t));
        return () => observer.disconnect();
    }, []);

    return (
        <section id="about" className="section" ref={sectionRef}>
            <div className="about-grid">
                {/* Visual */}
                <div className="about-visual fade-up">
                    <div className="about-img-wrap">
                        <div className="about-pattern" />
                        <MdBusinessCenter className="about-icon-big" />
                    </div>
                    <div className="about-badge">
                        <span>12+</span>
                        Years of<br />Excellence
                    </div>
                </div>

                {/* Text */}
                <div className="about-text">
                    <p className="section-label fade-up delay-1">Who We Are</p>
                    <h2 className="section-title fade-up delay-2">
                        Your Trusted Partner<br />
                        in <span className="gradient-text">Sierra Leone</span>
                    </h2>
                    <p className="section-subtitle fade-up delay-3">
                        Founded in Freetown, CONNECT ALL (SL) LTD has grown into Sierra Leone's
                        most trusted consulting group. We bridge the gap between ambitious
                        businesses and the strategies, technology, and talent they need to excel
                        on both regional and global stages.
                    </p>
                    <div className="about-cards">
                        {CARDS.map((card, i) => (
                            <div
                                key={i}
                                className={`about-card fade-up delay-${i + 3}`}
                            >
                                <div className="about-card-icon">{card.icon}</div>
                                <h4>{card.title}</h4>
                                <p>{card.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;

